import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import FilterCasinoReport from 'views/machine/reports/casinoReport/filterCasinoReport'; // Importing filter component
import TableCasinoReport from 'views/machine/reports/casinoReport/tableCasinoReport'; // Importing table component
import DetailsCasinoReport from 'views/machine/reports/casinoReport/detailsCasinoReport'; // Importing details component
import RecordCasinoReport from 'views/machine/reports/casinoReport/recordCasinoReport'; // Importing record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [RecordCasinoReport, DetailsCasinoReport], // Rows for the right section
        };
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar1',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select',
                    options: ['10', '20', '50', '100'], // Pagination options
                    width: 70,
                    on: {
                        onChange: function () {
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the data table
                        },
                    },
                },
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export1',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export select
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index
                            var last = first + size - 1; // Last item index
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    filter: function (obj) {
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last // Filter for pagination
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Casino', // Filename for export
                                    ignore: { detailTittle: true, Type: true }, // Ignore specific fields
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        filter: function (obj) {
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last // Filter for pagination
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Casino', // Filename for export
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            Type: true, // Ignore specific fields
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export1').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            height: screen.width < 500 ? 500 : 0, // Responsive height
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply theme to toolbar
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de Casino'), // Label for the report
                            width: 300,
                        },
                    ],
                },
                FilterCasinoReport, // Filter component
                TableCasinoReport, // Table component
                toolbar, // Toolbar component
            ],
        };
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }], // Advanced details section
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left, avanc], // Layout with left and advanced sections
                },
            ],
        };
    }
}

// FILE DOCUMENTED
